/*{"ResultStatus":false,"ResultObject":[],"ResultObjectEx":"","ErrorList":["Please enter URL to the textbox below."]}*/

import {ProcessResult} from "../../domain/process-result/interfaces";
import {IOption} from "../../ui/forms/fields/select-react-field";

export interface Response {
    statusCode: number,
    data: any
}
export interface OptionLabelValue {
    label:string,
    value:string
}
export interface SelectReactSources {
    id:string,
    dataSource:IOption[]
}

export interface ContactUsFormsWrapper {
    formComponentList:FormComponentDM [],
    formSettings:FormSettings
    formConfiguration: FormConfiguration,
    pResult: ProcessResult,
    formName:string,
    captchaCode: string | undefined,
    recaptchaVersion: number | undefined,
}
export interface FormSendWrapper {
    formComponentList:FormComponentDM [],
    formName:string,
    captchaCode:string,
    recaptchaVersion: number
}
export interface FormComponentDM {
    gUID: string;
    propertiesType: string;
    name: string;
    dataSource:IOption[];
    dataType: string;
    defaultValue: string;
    label: string;
    tooltip: string;
    explanationText: string;
    size: number;
    required: boolean;
    smartField: boolean;
    visible: boolean;
    valueToSave:any;
}




/*---------------------------------------------------------------FormComponent*/
    export interface FormComponent {
        identifier: string;
        typeIdentifier?: any;
        properties?: any;
    }

    export interface Zone {
        identifier: string;
        name: string;
        formComponentList: FormComponentDM[];
    }

    export interface Section {
        identifier: string;
        typeIdentifier: string;
        zones: Zone[];
        properties?: any;
    }

    export interface EditableArea {
        identifier: string;
        sections: Section[];
    }

    export interface FormConfiguration {
        editableAreas: EditableArea[];
    }

    export interface FormSettings{
        formSubmitButtonText: string;
        formDisplayName: string;
        formDisplayText: string;
        formRedirectToUrl: string;
        formAfterSubmit: FormAfterSubmitType;
        formSettingsEmail:FormSettingsEmail
    }
export interface FormSettingsEmail{
    formSendFromEmail: string;
    formSendToEmail: string;
}

export enum FormAfterSubmitType {
    DisplayText = 0,
    RedirectToUrl = 1,
    ReloadForm = 2,
}



